import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"

import {claimPopup,popupAvailable,releasePopup} from '@/utils/popupDisplay'
import {computed,onMounted,onBeforeUnmount,ref,watch,nextTick} from 'vue'
import {adminNoticeBlocking,couponReceiptBlocking} from '@/utils/adminNoticeRuntime'
import ActivityCouponCard from '@/views/components/ActivityCouponCard.vue'
import {useRoute,useRouter} from 'vue-router'
import store from '@/store'
import request from '@/utils/request'
import {activityBrowsePaths,createActivityVisit,validWebActivity,activityCouponTarget,claimActivityInterval,activityIntervalReady} from '@/utils/activityCoupon'
import {couponFreeProductDetail} from '@/utils/couponDisplayRules'

export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityCoupon',
  props: {
    ready: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {ready:boolean};

const popupOwner={}
const route=useRoute(),router=useRouter()
const visible=ref(false),config=ref<any>({}),visit=createActivityVisit()
const collapsed=ref<any>(null)
let schedule:ReturnType<typeof setInterval>|undefined
let serial=0,timer:ReturnType<typeof setTimeout>|undefined
const scope=computed(()=>props.ready && Number(store.getters.orgInfo?.id)===Number(store.getters.orgId)?Number(store.getters.orgId):0)
const allowed=computed(()=>scope.value>=1000 && activityBrowsePaths.has(route.path) && document.visibilityState!=='hidden' && !adminNoticeBlocking.value && !couponReceiptBlocking?.value)
const canReopen=computed(()=>!visible.value && allowed.value && !couponFreeProductDetail(route.path) && Number(collapsed.value?.orgId)===scope.value && validWebActivity(collapsed.value))
const close=(advance=false)=>{releasePopup(popupOwner);if(visible.value && config.value.mode==='coupon')collapsed.value=config.value;visible.value=false;clearTimeout(timer);if(advance)timer=setTimeout(()=>void check(),1200)}
async function reopen(){
  if(!canReopen.value)return
  const current=++serial,orgId=scope.value,previous=collapsed.value
  try{const response=await request({url:'fsystem/activityCoupon/campaigns',method:'GET',params:{orgId}})
    const value=(Array.isArray(response.data)?response.data:[response.data]).find(item=>item?.mode==='coupon' && Number(item.orgId)===orgId && (item.campaignId || item.templateId)===(previous.campaignId || previous.templateId) && validWebActivity(item))
    if(current!==serial || orgId!==scope.value || !allowed.value || couponFreeProductDetail(route.path))return
    if(!value){collapsed.value=null;return}if(!claimPopup(popupOwner,'client-activity-shell'))return;clearTimeout(timer);config.value=value;visible.value=true;timer=setTimeout(()=>{collapsed.value=null;close()},Math.max(0,value.endTime-Date.now()))
  }catch{/* 手动展开读取失败时保留入口，不显示陈旧活动内容。 */}
}
async function check(){
  if(visible.value)return
  const current=++serial,orgId=scope.value;if(!allowed.value || !popupAvailable(popupOwner,'client-activity-shell'))return
  try{
    const response=await request({url:'fsystem/activityCoupon/campaigns',method:'GET',params:{orgId}}),values=Array.isArray(response.data)?response.data:[response.data]
    const value=values.find((item:any)=>!(couponFreeProductDetail(route.path) && item?.mode==='coupon') && Number(item?.orgId)===orgId && validWebActivity(item) && !visit.has(orgId+':'+(item.campaignId || item.templateId)+':'+item.startTime) && activityIntervalReady(orgId+':'+(item.campaignId || item.templateId)+':'+item.startTime,item.repeatHours,k=>localStorage.getItem(k)))
    if(current!==serial || orgId!==scope.value || !allowed.value || Number(value?.orgId)!==orgId || !validWebActivity(value))return
    const key=orgId+':'+(value.campaignId || value.templateId)+':'+value.startTime
    if(visit.has(key) || !activityIntervalReady(key,value.repeatHours,k=>localStorage.getItem(k)))return
    if(!claimPopup(popupOwner,'client-activity-shell'))return
    config.value=value;visible.value=true;await nextTick()
    if(current!==serial || orgId!==scope.value || !allowed.value){close();return}
    if(!claimActivityInterval(key,value.repeatHours,k=>localStorage.getItem(k),(k,v)=>localStorage.setItem(k,v)) || !visit.claim(key)){close();return}
    timer=setTimeout(()=>close(true),Math.max(0,Math.min(value.popupSeconds*1000,value.endTime-Date.now())))
  }catch{/* 活动失败不阻止浏览，不回落到其他机构活动。 */}
}
async function viewCoupons(){
  close()
  if(config.value.mode==='coupon'){
    const target=activityCouponTarget(config.value,scope.value);if(!target)return
    await router.push({path:'/main/cuscenter/notes',query:{activityCouponId:String(target.couponId),activityOrgId:String(target.orgId)}})
    if(!store.getters.token || !store.getters.userInfo?.id || Number(store.getters.userInfo.orgId)!==target.orgId)store.state.user.loginCallback?.()
    return
  }
  if(!store.getters.token || !store.getters.userInfo?.id){void router.push('/prelogin');return}
  void router.push('/main/cuscenter/notes')
}
watch(()=>[scope.value,allowed.value],()=>{if(!allowed.value){serial++;close()}else void check()},{immediate:true})
watch(scope,()=>{serial++;close();collapsed.value=null;void check()})
function visibility(){serial++;close();if(document.visibilityState!=='hidden'){visit.begin();void check()}}
onMounted(()=>{schedule=setInterval(()=>{if(!visible.value)void check()},30000)})
document.addEventListener('visibilitychange',visibility)
onBeforeUnmount(()=>{clearInterval(schedule);serial++;close();document.removeEventListener('visibilitychange',visibility)})

return (_ctx: any,_cache: any) => {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(canReopen))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "coupon-reopen-entry",
          type: "button",
          "aria-label": "再次展开优惠券",
          onClick: reopen
        }, "优惠券 · 展开"))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: visible.value && !_unref(adminNoticeBlocking),
      footer: null,
      closable: false,
      "mask-closable": false,
      width: 390,
      "wrap-class-name": "client-activity-shell",
      "body-style": {padding:'0',background:'transparent'},
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (close(true)))
    }, {
      default: _withCtx(() => [
        _createVNode(ActivityCouponCard, {
          config: config.value,
          onView: viewCoupons
        }, null, 8, ["config"]),
        _createElementVNode("button", {
          class: "activity-close",
          type: "button",
          "aria-label": "关闭活动弹窗",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (close(true)))
        }, "×")
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})